/* es5-ext/object/valid-callable */ function _(require, module, exports) {
    module.exports = function (fn) {
        if (typeof fn !== "function")
            throw new TypeError(fn + " is not a function");
        return fn;
    };
}
